var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar',{on:{"changeRole":_vm.changeRole}}),_c('div',{staticClass:"content"},[_c('side-bar',{attrs:{"role":_vm.role}}),_c('app-main')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }